// 三方十类：三方 = 建设期 / 运营期 / 支撑服务方，十类 = 10 个企业角色
export const PARTIES = [
  {"id": "construction", "name": "第一方 · 建设期参与方", "desc": "工程项目的投资、勘察、设计、施工、供应与装备主体"},
  {"id": "operation", "name": "第二方 · 运营期参与方", "desc": "资产运营与检测监测主体"},
  {"id": "support", "name": "第三方 · 支撑服务方", "desc": "为数据贯通提供平台与技术支撑的数字化服务商"},
]

// 十类角色；projectPosts 为项目级对应岗位（文档 4.2 节映射关系）
export const ROLES = [
  {"id": "invest-construct", "name": "投资运营企业（建设侧）", "party": "construction", "projectPosts": ["项目经理", "项目总工", "工程部长", "合同部长", "质量部长", "数据管理员"]},
  {"id": "survey", "name": "勘察单位", "party": "construction", "projectPosts": ["项目勘察负责人", "测量工程师", "岩土试验员", "成果报告编制人"]},
  {"id": "design", "name": "设计研究院", "party": "construction", "projectPosts": ["项目设计负责人", "BIM总监", "各专业BIM建模师"]},
  {"id": "supervision", "name": "工程咨询监理造价单位", "party": "construction", "projectPosts": ["总监/总监代表", "现场监理工程师", "造价工程师", "资料员"]},
  {"id": "contractor", "name": "施工单位", "party": "construction", "projectPosts": ["项目总工", "现场施工员", "质量员", "安全员", "物资管理员", "BIM专员"]},
  {"id": "material", "name": "材料与构配件供应商", "party": "construction", "projectPosts": ["现场供应负责人", "质检员", "物流调度员"]},
  {"id": "equipment", "name": "装备制造企业", "party": "construction", "projectPosts": ["项目现场技术服务工程师", "设备安装负责人"]},
  {"id": "invest-operation", "name": "投资运营企业（运营侧）", "party": "operation", "projectPosts": ["运营负责人", "资产管理员", "养护工程师", "调度员"]},
  {"id": "monitoring", "name": "检测监测单位", "party": "operation", "projectPosts": ["现场检测负责人", "监测技术员", "数据审核人"]},
  {"id": "digital-service", "name": "数字化与软件服务商", "party": "support", "projectPosts": ["项目实施经理", "技术架构师", "接口开发工程师", "驻场运维工程师"]},
]

export const ROLE_MAP = Object.fromEntries(ROLES.map((r) => [r.id, r]))

export const ROLES_BY_PARTY = Object.fromEntries(
  PARTIES.map((p) => [p.id, ROLES.filter((r) => r.party === p.id)])
)
